export function isLocalUrl(href: string) {
	return href.includes(String(process.env.NEXT_PUBLIC_WEB_URL)) || href.startsWith('/') || href.startsWith('#')
}
